module.exports = __webpack_public_path__ + "static/assets/d5e6113d1d33338f1f218fdae2b63f49.svg";